var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 40,
    viewBox: "0 0 130 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H124C127.314 0 130 2.68629 130 6V34C130 37.3137 127.314 40 124 40H6C2.68629 40 0 37.3137 0 34V6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43466 7.5471C9.14366 7.8551 8.97266 8.3321 8.97266 8.9511V31.0491C8.97266 31.6681 9.14366 32.1451 9.43466 32.4531L9.50866 32.5251L21.8877 20.1461V19.8541L9.50866 7.4751L9.43466 7.5471Z",
    fill: "#00D7FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 12,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0127 24.2741L21.8877 20.1461V19.8541L26.0147 15.7271L30.9967 18.5571C32.3927 19.3511 32.3927 20.6491 30.9967 21.4421L26.1077 24.2201L26.0127 24.2741Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0127 24.2741L21.8877 20.1461V19.8541L26.0147 15.7271L30.9967 18.5571C32.3927 19.3511 32.3927 20.6491 30.9967 21.4421L26.1077 24.2201L26.0127 24.2741Z",
    fill: "url(#paint0_linear)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 20,
    width: 18,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1076 24.22L21.8876 20L9.43457 32.453C9.89557 32.94 10.6556 33 11.5116 32.514L26.1076 24.22Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1076 24.22L21.8876 20L9.43457 32.453C9.89557 32.94 10.6556 33 11.5116 32.514L26.1076 24.22Z",
    fill: "url(#paint1_linear)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 18,
    height: 13
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1076 15.7801L11.5116 7.48605C10.6556 7.00005 9.89557 7.06005 9.43457 7.54705L21.8876 20.0001L26.1076 15.7801Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1076 15.7801L11.5116 7.48605C10.6556 7.00005 9.89557 7.06005 9.43457 7.54705L21.8876 20.0001L26.1076 15.7801Z",
    fill: "url(#paint2_linear)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.894 30.953H105.76V18.452H103.894V30.953ZM120.701 22.955L118.562 28.375H118.498L116.278 22.955H114.268L117.597 30.53L115.699 34.744H117.646L122.776 22.955H120.701ZM110.119 29.533C109.507 29.533 108.655 29.228 108.655 28.472C108.655 27.507 109.717 27.137 110.633 27.137C111.454 27.137 111.839 27.314 112.338 27.555C112.193 28.713 111.196 29.533 110.119 29.533ZM110.344 22.682C108.993 22.682 107.594 23.277 107.015 24.596L108.671 25.287C109.025 24.596 109.684 24.37 110.376 24.37C111.341 24.37 112.322 24.949 112.338 25.979V26.107C112 25.914 111.277 25.625 110.392 25.625C108.607 25.625 106.789 26.606 106.789 28.439C106.789 30.112 108.253 31.19 109.893 31.19C111.148 31.19 111.839 30.627 112.274 29.967H112.338V30.932H114.139V26.14C114.139 23.92 112.483 22.682 110.344 22.682ZM98.812 24.477H96.158V20.192H98.812C100.207 20.192 100.999 21.347 100.999 22.334C100.999 23.303 100.207 24.477 98.812 24.477ZM98.764 18.452H94.293V30.953H96.158V26.217H98.764C100.832 26.217 102.865 24.719 102.865 22.334C102.865 19.949 100.832 18.452 98.764 18.452ZM74.383 29.535C73.094 29.535 72.015 28.456 72.015 26.974C72.015 25.476 73.094 24.38 74.383 24.38C75.656 24.38 76.654 25.476 76.654 26.974C76.654 28.456 75.656 29.535 74.383 29.535ZM76.525 23.655H76.461C76.042 23.156 75.237 22.705 74.222 22.705C72.095 22.705 70.146 24.573 70.146 26.974C70.146 29.358 72.095 31.211 74.222 31.211C75.237 31.211 76.042 30.76 76.461 30.244H76.525V30.856C76.525 32.484 75.656 33.354 74.254 33.354C73.11 33.354 72.401 32.532 72.111 31.839L70.484 32.516C70.951 33.644 72.192 35.029 74.254 35.029C76.445 35.029 78.298 33.74 78.298 30.599V22.962H76.525V23.655ZM79.587 30.953H81.456V18.451H79.587V30.953ZM84.21 26.829C84.162 25.186 85.483 24.348 86.433 24.348C87.175 24.348 87.803 24.718 88.012 25.25L84.21 26.829ZM90.01 25.411C89.656 24.461 88.576 22.705 86.369 22.705C84.178 22.705 82.358 24.428 82.358 26.958C82.358 29.342 84.162 31.211 86.578 31.211C88.528 31.211 89.656 30.019 90.123 29.326L88.673 28.359C88.19 29.068 87.529 29.535 86.578 29.535C85.628 29.535 84.951 29.1 84.516 28.247L90.203 25.895L90.01 25.411ZM44.702 24.01V25.814H49.019C48.89 26.829 48.552 27.57 48.037 28.086C47.408 28.714 46.425 29.406 44.702 29.406C42.044 29.406 39.965 27.264 39.965 24.606C39.965 21.947 42.044 19.805 44.702 19.805C46.136 19.805 47.183 20.369 47.956 21.094L49.229 19.821C48.149 18.79 46.716 18 44.702 18C41.061 18 38 20.965 38 24.606C38 28.247 41.061 31.211 44.702 31.211C46.667 31.211 48.149 30.567 49.309 29.358C50.501 28.166 50.872 26.491 50.872 25.137C50.872 24.718 50.84 24.332 50.775 24.01H44.702ZM55.781 29.535C54.492 29.535 53.38 28.472 53.38 26.958C53.38 25.427 54.492 24.38 55.781 24.38C57.069 24.38 58.181 25.427 58.181 26.958C58.181 28.472 57.069 29.535 55.781 29.535ZM55.781 22.705C53.428 22.705 51.511 24.493 51.511 26.958C51.511 29.406 53.428 31.211 55.781 31.211C58.133 31.211 60.05 29.406 60.05 26.958C60.05 24.493 58.133 22.705 55.781 22.705ZM65.094 29.535C63.805 29.535 62.693 28.472 62.693 26.958C62.693 25.427 63.805 24.38 65.094 24.38C66.383 24.38 67.494 25.427 67.494 26.958C67.494 28.472 66.383 29.535 65.094 29.535ZM65.094 22.705C62.742 22.705 60.825 24.493 60.825 26.958C60.825 29.406 62.742 31.211 65.094 31.211C67.446 31.211 69.363 29.406 69.363 26.958C69.363 24.493 67.446 22.705 65.094 22.705Z",
    fill: "#FFFFFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4668 13.1606C43.25 13.4712 42.9468 13.7041 42.5571 13.8594C42.1704 14.0117 41.7192 14.0879 41.2036 14.0879C40.6821 14.0879 40.2192 13.9663 39.8149 13.7231C39.4106 13.4771 39.0972 13.1284 38.8745 12.6772C38.6548 12.2261 38.542 11.7031 38.5361 11.1084V10.5503C38.5361 9.58643 38.7603 8.83936 39.2085 8.30908C39.6597 7.77881 40.2925 7.51367 41.1069 7.51367C41.7749 7.51367 42.3125 7.68506 42.7197 8.02783C43.127 8.36768 43.376 8.85107 43.4668 9.47803H42.623C42.4648 8.63135 41.9609 8.20801 41.1113 8.20801C40.5459 8.20801 40.1167 8.40723 39.8237 8.80566C39.5337 9.20117 39.3872 9.77539 39.3843 10.5283V11.0513C39.3843 11.769 39.5483 12.3403 39.8765 12.7651C40.2046 13.187 40.6484 13.3979 41.208 13.3979C41.5244 13.3979 41.8013 13.3628 42.0386 13.2925C42.2759 13.2222 42.4722 13.1035 42.6274 12.9365V11.4995H41.1465V10.814H43.4668V13.1606ZM48.2241 11.0425H45.4512V13.3101H48.6724V14H44.6074V7.60156H48.6284V8.2959H45.4512V10.3525H48.2241V11.0425ZM53.9615 8.2959H51.9048V14H51.0655V8.2959H49.0132V7.60156H53.9615V8.2959ZM57.3326 14H56.4888V7.60156H57.3326V14ZM62.8985 8.2959H60.8419V14H60.0025V8.2959H57.9503V7.60156H62.8985V8.2959ZM70.2863 11.0073C70.2863 11.6343 70.1808 12.1821 69.9699 12.6509C69.7589 13.1167 69.4601 13.4727 69.0734 13.7188C68.6867 13.9648 68.2355 14.0879 67.7199 14.0879C67.216 14.0879 66.7692 13.9648 66.3795 13.7188C65.9899 13.4697 65.6867 13.1167 65.4699 12.6597C65.256 12.1997 65.1461 11.668 65.1403 11.0645V10.603C65.1403 9.98779 65.2472 9.44434 65.4611 8.97266C65.6749 8.50098 65.9767 8.14062 66.3663 7.8916C66.7589 7.63965 67.2072 7.51367 67.7111 7.51367C68.2238 7.51367 68.6749 7.63818 69.0646 7.88721C69.4572 8.1333 69.7589 8.49219 69.9699 8.96387C70.1808 9.43262 70.2863 9.979 70.2863 10.603V11.0073ZM69.4469 10.5942C69.4469 9.83545 69.2946 9.25391 68.9899 8.84961C68.6852 8.44238 68.2589 8.23877 67.7111 8.23877C67.1779 8.23877 66.7575 8.44238 66.4498 8.84961C66.1452 9.25391 65.9884 9.81641 65.9796 10.5371V11.0073C65.9796 11.7427 66.1334 12.3213 66.4411 12.7432C66.7516 13.1621 67.1779 13.3716 67.7199 13.3716C68.2648 13.3716 68.6867 13.1738 68.9855 12.7783C69.2843 12.3799 69.4381 11.8101 69.4469 11.0688V10.5942ZM76.1994 14H75.3512L72.13 9.06934V14H71.2819V7.60156H72.13L75.36 12.5542V7.60156H76.1994V14Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 30.0885,
    y1: 20.0004,
    x2: 21.8877,
    y2: 20.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 23.8142,
    y1: 23.9708,
    x2: 13.1107,
    y2: 32.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 11.3202,
    y1: 9.04621,
    x2: 18.4565,
    y2: 15.3211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ED574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/googlePlay.e2eecf740db82f796ff20a2bd049558f.svg";
export { ForwardRef as ReactComponent };